//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import {
    mapState,
    mapMutations
  } from 'vuex'

  export default {
    data() {
      return {
        
      }
    },
    props: ['spec','index','outofstock'],
    async beforeMount() {},
    mounted() {

    },
    components: {},
    computed: {
      ...mapState(['specName','specNameEn']),
      
      specNames(){
         return  this.$i18n.locale  === 'en' ? this.specNameEn : this.specName;
      },
      currentSpec() {
        if (this.spec && this.spec.spec1) {
          return this.spec.spec1[this.index].spec
        } else {
          return 0
        }
      },
      spec1() {
        if (this.spec && this.spec.spec1) {
          return this.spec.spec1
        } else {
          return []
        }
      }
    },
    methods: {
      selectSpec(spec,index){
        if(spec.stock==0){
          return false
        }
        this.$emit('selectSpec', spec,index)
      }
    },
    watch: {}
  }




// WEBPACK FOOTER //
// ./src/components/card/norm.vue